import { Component, Input, input } from '@angular/core';
import { TranslatePipe } from "@ngx-translate/core";
import { AppIntegrationFromTo } from "./DashboardIntegrations";

@Component({
  selector: 'IntegrationApp',
  imports: [TranslatePipe],
  template: `
    <div
        class="
        w-full px-4 pt-8 pb-6 center flex-col text-center h-full md:px-5
        {{ app?.apiName ? 'bg-white' : 'bg-blue-200' }}
      "
    >
      @if (app?.apiNameNormalized) {
        <img
            [alt]="app.apiName"
            class="w-3/5 max-w-[80px] aspect-square mb-3 {{
          active() ? '' : 'opacity-60'
        }}"
            src="assets/images/apps/{{ app.apiNameNormalized }}.svg"
            height="80"
            width="80"
        />
      }

      @if (!app?.apiNameNormalized) {
        <div class="
          w-1/2 max-w-[80px] aspect-square mb-3
          bg-blue-500 rounded-full shadow-blue-500/50 center"
        >
          <svg
              class="w-1/2 aspect-square text-white"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              xmlns="http://www.w3.org/2000/svg"
          >
            <g
                stroke="currentColor"
                stroke-width="4"
                fill="none"
                fill-rule="evenodd"
            >
              <path d="M0 15.5h30M15.5 0v30"/>
            </g>
          </svg>
        </div>
      }

      <h3 class="text-base mb-0 md:mb-2 transition-colors group-hover:text-blue-500">
        {{ app?.apiName || ('APPINTEGRATIONS_MISSING_CTA' | translate) }}
      </h3>

      @if (description) {
        <p class="text-xxs max-w-full md:-mt-2 md:mb-2 break-words"
           [innerHTML]="description"
        ></p>
      }
    </div>
  `,
})
export class IntegrationApp {
  readonly active = input(true);
  @Input() app?: AppIntegrationFromTo;
  @Input() description = '';
}
